// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { list16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-list': IconList;
    }
}

/**
 * The icon component for the 'list' icon
 */
export class IconList extends Icon {
    public constructor() {
        super(list16X16);
    }
}

registerIcon('icon-list', IconList);
export const iconListTag = 'nimble-icon-list';
